import { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormLabel,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import * as yup from "yup";
import http from "../../utils/http";
import { errorToastMessage, toastMessage } from "../../utils/toast";
import {
  ModalDrawerButtonStyles,
  ModalDrawerStyles,
  ModalHeaderTitleStyles,
} from "../Common/styles/modal";
import { InputWrapper, LabelStyle } from "../Common/styles/form";
import { CloseOutlined } from "@mui/icons-material";
import { DrawerForm } from "../Common/styles/drawer";

let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  description: yup.string().required("Description is Required"),
});

const AddTemplateModal = ({
  showModal,
  closeModal,
  data,
  studyId,
  refreshPage,
  formId,
  type,
  formType,
}: any) => {
  const [submitLoader, setSubmitLoader] = useState(false);
  const submitHandler = async (values: any) => {
    try {
      setSubmitLoader(true);
      const body = {
        ...values,
        type: type,
      };
      const prefix =
        formType === "platform" ? "/admin/registry/" : `/study/${studyId}/`;
      const res = await http.post(
        `${prefix}forms/${formId}/save-template`,
        body
      );
      closeModal();
      toastMessage("success", res.data.message);
      setSubmitLoader(false);
      refreshPage();
    } catch (err) {
      errorToastMessage(err as Error);
      setSubmitLoader(false);
    }
  };

  return (
    <Modal open={showModal} onClose={closeModal}>
      <Box sx={ModalDrawerStyles}>
        <Stack direction={"row"} alignItems={"center"} gap={2}>
          <Typography
            sx={{
              ...ModalHeaderTitleStyles,
              flex: 1,
              minWidth: "0px",
            }}
            title="Add Template"
            noWrap
          >
            Add Template
          </Typography>

          <IconButton onClick={closeModal}>
            <CloseOutlined />
          </IconButton>
        </Stack>

        <Divider sx={{ my: 2 }} />

        <Formik
          initialValues={{
            title: "",
            description: "",
            type: type,
          }}
          validationSchema={schema}
          onSubmit={(values) => {
            submitHandler(values);
          }}
        >
          {({ getFieldProps, errors, touched, values, setFieldValue }) => (
            <Form style={DrawerForm}>
              <FormControl sx={InputWrapper}>
                <FormLabel sx={LabelStyle} htmlFor="title">
                  Title <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <TextField
                  placeholder="Title"
                  id="title"
                  {...getFieldProps("title")}
                  error={touched?.title && errors?.title ? true : false}
                  helperText={
                    touched?.title && errors?.title
                      ? (errors?.title as string)
                      : " "
                  }
                />
              </FormControl>
              <FormControl sx={InputWrapper}>
                <FormLabel sx={LabelStyle} htmlFor="description">
                  Description <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <TextField
                  multiline
                  rows={4}
                  placeholder="Description"
                  id="description"
                  {...getFieldProps("description")}
                  error={
                    touched?.description && errors?.description ? true : false
                  }
                  helperText={
                    touched?.description && errors?.description
                      ? (errors?.description as string)
                      : " "
                  }
                />
              </FormControl>

              <Box sx={{ mt: "auto" }}>
                <Divider />
                <Box sx={ModalDrawerButtonStyles}>
                  {!submitLoader ? (
                    <>
                      <Button onClick={closeModal} variant="outlined">
                        Cancel
                      </Button>
                      <Button type="submit" variant="contained">
                        Save
                      </Button>
                    </>
                  ) : (
                    <CircularProgress size={25} />
                  )}
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default AddTemplateModal;
